import { render, staticRenderFns } from "./ListCreativeReviews.vue?vue&type=template&id=6ccd79d5&scoped=true"
import script from "./ListCreativeReviews.vue?vue&type=script&lang=js"
export * from "./ListCreativeReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccd79d5",
  null
  
)

export default component.exports